import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import StuTestHistoryComp from "./Component/StuTestHistoryComp"


const StuTestHistory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <StuTestHistoryComp />
        </div>
        <Footer />
        </>
    )
}

export default StuTestHistory